// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__MuAAp","loading":"style_loading__pcEJi"};